;(function () {

"use strict";

var ObjectConfigFormTemplate = require('../views/templates/object-config-form.html');
var ConfigFormView = require('../views/config-form.js');

var metafieldInputTemplate = require('../views/templates/object-metafield-input.html');

var CreateConfigFormView = ConfigFormView.extend({
  className: 'row',
  initialize: function (opts) {
    opts = opts || {};
    opts.url = '/objects/config';
    opts.noListeners = true;
    ConfigFormView.prototype.initialize.call(this, opts);

    this.$anchor = opts.$anchor;
    console.log('init create config form view');
    this.render();
  },
  submit: function () {
    return false;
  },
  render: function () {
    var html = _.template(ObjectConfigFormTemplate)();
    this.$el.html(html);
    console.log(this.$anchor[0]);
    this.$el.insertBefore(this.$anchor);

    this.$appendTarget = this.$el.find('.card-section.metafields');
  }
});

var ObjectConfigFormView = ConfigFormView.extend({
    removeCustomObject: function (e) {
      $(e.currentTarget).closest('.object').remove();
      window.App.Events.trigger('submit');
    },
    add: function (e) {
      console.log('adding a meta field input row');
      var html;

      if ($(e.currentTarget).closest('div.object').hasClass("shop")) {
        console.log('SHOP');
        html = _.template(metafieldInputTemplate)({isShop: true});
      } else {
        html = _.template(metafieldInputTemplate)();
      }
      var $this = $(e.currentTarget);

      if (this.$appendTarget) {
        $(html).appendTo(this.$appendTarget);
      } else {
        $(html).insertBefore($this.parent());      
      }

      var $section = $this.closest('.object');
      this.resetArrows($section);

      return false;
    },
    events: _.extend({}, ConfigFormView.prototype.events, {
    'click .remove-custom-object': function (e) {
      var self = this;

      ShopifyApp.Modal.confirm({
        title: 'Delete Custom Object',
        message: "Are you sure you want to delete this custom object?",
        okButton: "Yes, delete this custom object",
        cancelButton: "No, keep this custom object",
        style: "danger"
      }, function (result) {

        if (result === true) {
          self.removeCustomObject(e);
        }

      });

      e.stopPropagation();
      e.preventDefault();
    }
  })  
});

var PageView = Backbone.View.extend({
  initialize: function () {
    console.log('init object config view');
    var forms = [];

    this.$el.find('form.object').each(function () {
      forms.push(new ObjectConfigFormView({
        el: this, 
        url: '/objects/config',
        $appendTarget: $(this).find('.card-section.metafields'),
        noListeners: true }));
    });

    window.Buttons = {
      primary: {
        label: "Save Configuration",
        message: 'config_form_submit',
        loading: true,
        callback: function (message, data) {
          window.App.Events.trigger('submit');
        }
      }
    };

    this.forms = forms;

    window.App.Events.on('submit', _.bind(this.save, this));
  },
  create: function (e) {
    var $this = $(e.currentTarget);
    this.forms.push(new CreateConfigFormView({ $anchor: $this.closest('section') }));
  },
  save: function () {
    var data = {};

    _.each(this.forms, function (form) {
      _.extend(data, form.generateData());
    });

    data.__shop__ = window.data.shop;
    var json = JSON.stringify(data);

    $.post('/objects/config', {json: json}, _.bind(function (d) {
      if (d.status === 'success') {
        this.success(d);
      } else {
        ShopifyApp.Modal.alert({
          title: d.err,
          message: 'Sorry, Something went wrong. Please try this action again or contact jason@thebestagency.com for more help.'
        });
      }
    }, this));
  },
  success: function (d) {
    ShopifyApp.Modal.alert({
      title: 'Success!',
      message: 'Your configuration has been saved. You can now populate metafields for the specified objects.'
    }, function () {
      window.location.reload();
    });
  },
  events: {
    'click button.new': 'create',
    'click button.save': 'save'
  }
});

module.exports = PageView;

}());